import {B2cUserAttribute} from '../../../integrated-client/models';
import {DEFAULT_PAGE_SIZE, DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  filterType?: B2cUserAttribute;
  filterKeyword?: string;
  pageSize?: number;
  skipToken?: string;
  total: number
  currentPage: number
}

export class FormData implements IFormData {
  filterType?: B2cUserAttribute;
  filterKeyword?: string;
  pageSize?: number;
  skipToken?: string;
  total: number
  currentPage: number

  constructor() {
    this.filterType = B2cUserAttribute.EmailAddress;
    this.filterKeyword = undefined;
    this.pageSize = DEFAULT_PAGE_SIZE;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }

}
